import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance, { axiosFormInstance } from "../../api/axiosInstance";
import { endpoints } from "../../api/endpoints";
import { updateShortlistedCandidates } from "../Client/ShortListCandidate";

export const fetchAllMasterData = createAsyncThunk(
  "candidate/fetchAllMasterData",
  async (_, thunkAPI) => {
    try {
      const response = await axiosInstance.get(endpoints.getallmasterdata);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);
export const fetchAllIndustryData = createAsyncThunk(
  "candidate/fetchAllIndustryData",
  async (_, thunkAPI) => {
    try {
      const response = await axiosInstance.get(endpoints.getallindustrydata);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const submitCandidateInfo = createAsyncThunk(
  "candidate/submitCandidateInfo",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await axiosFormInstance.post(
        endpoints.addupdatecandidateinfo,
        formData
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const fetchCandidates = createAsyncThunk(
  "candidates/fetchCandidates",
  async (search, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        endpoints.searchcandidates,
        search
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);
export const fetchCandidatesBySearchLog = createAsyncThunk(
  "candidates/fetchCandidatesBySearchLog",
  async (search, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        endpoints.searchcandidatesbysearchlog,
        search
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const updateResumeDownloadLimit = createAsyncThunk(
  "candidate/updateResumeDownloadLimit",
  async (downloadData, thunkAPI) => {
    try {
      const response = await axiosInstance.post(
        endpoints.downloadlimit,
        downloadData
      );
      console.log(response?.data);

      return response?.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);
export const updateCandidateStatus = createAsyncThunk(
  "candidate/updateCandidateStatus",
  async (clientData, thunkAPI) => {
    try {
      const response = await axiosInstance.post(
        endpoints.updatestatusofcandidateinviewdetail,
        clientData
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);
export const fetchSearchHistory = createAsyncThunk(
  "candidate/fetchSearchHistory",
  async (userId, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        endpoints.getallsearchhistory,
        userId
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

const initialState = {
  data: null,
  searchHistoryData: null,
  loading: false,
  downloadLimitloading: false,
  error: null,
  searchLogId: null,
  candidates: [],
  resumeDownloadLimit: null,
  candidateStatus: null,
};
const candidateSlice = createSlice({
  name: "candidate",
  initialState,
  reducers: {
    clearCandidates: (state) => {
      state.candidates = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(submitCandidateInfo.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(submitCandidateInfo.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(submitCandidateInfo.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchCandidates.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCandidates.fulfilled, (state, action) => {
        state.loading = false;
        state.candidates = action.payload.data;
        state.searchLogId = action.payload.searchLogId;
      })
      .addCase(fetchCandidates.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchCandidatesBySearchLog.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCandidatesBySearchLog.fulfilled, (state, action) => {
        state.loading = false;
        state.candidates = action.payload.data;
      })
      .addCase(fetchCandidatesBySearchLog.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(updateResumeDownloadLimit.pending, (state) => {
        state.downloadLimitloading = true;
        state.error = null;
      })
      .addCase(updateResumeDownloadLimit.fulfilled, (state, action) => {
        state.downloadLimitloading = false;
        const { data, status, message } = action.payload;
        state.resumeDownloadLimit = data;
        if (status === 200) {
          state.candidates = state.candidates?.map((candidate) => {
            if (candidate._id.$oid === action?.meta?.arg?.candidateid) {
              return {
                ...candidate,
                isdownloaded: true,
                downloadinfo: candidate.downloadinfo
                  ? [...candidate.downloadinfo, ...message]
                  : [...message],
              };
            }
            return candidate;
          });
        }
      })
      .addCase(updateResumeDownloadLimit.rejected, (state, action) => {
        state.downloadLimitloading = false;
        state.error = action.payload;
      })
      .addCase(updateCandidateStatus.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateCandidateStatus.fulfilled, (state, action) => {
        state.loading = false;
        const { data, status, total } = action.payload;
        if (status === 200) {
          const candidateIndex = state.candidates.findIndex(
            (candidate) => candidate._id.$oid === data?.candidate_id?.$oid
          );
          if (candidateIndex !== -1) {
            const candidate = state.candidates[candidateIndex];
            const updatedCandidateStatusInfo = candidate.candidate_statusinfo
              ? [...candidate.candidate_statusinfo, data]
              : [data];
            state.candidates[candidateIndex] = {
              ...candidate,
              candidate_status: data?.status,
              candidate_clientid: data?.client_id,
              candidate_totalamount: total,
              candidate_statusinfo: updatedCandidateStatusInfo,
            };
          }
        }
        state.candidateStatus = action.payload;
      })
      .addCase(updateCandidateStatus.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchSearchHistory.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSearchHistory.fulfilled, (state, action) => {
        state.loading = false;
        state.searchHistoryData = action.payload.data;
        // state.searchHistoryData = action.payload.data.sort((a, b) => {
        //   const dateA = new Date(a.search_datetime.$date);
        //   const dateB = new Date(b.search_datetime.$date);
        //   return dateB - dateA;
        // });
      })
      .addCase(fetchSearchHistory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});
export const { clearCandidates } = candidateSlice.actions;
export default candidateSlice.reducer;
